import Input from "./Input";
import useInput from "../hooks/use-input";
import { useContext, useEffect, useState } from "react";
import { doesIdExist } from "../helpers/functions";
import { useLocation } from "react-router-dom";
import AuthContext from "../contexs/auth-contex";

const SubHeader = ({changeFilter}) => {

  const { user } = useContext(AuthContext);

  const sortList = [
    {
      name: "Poslednje ažurirano",
      id: null
    },
    {
      name: "Najnovije",
      id: 'date_entered',
    },
    {
      name: "Cena",
      id: 'price_sort',
    },
    {
      name: "Kategorija",
      id: 'category_sort',
    }
  ];

  const statusList = [
    {
      name: "Ponuda",
      id: 'offer'
    },
    {
      name: "Kupovina u toku",
      id: 'purchase_in_progress',
    },
    {
      name: "Lager",
      id: 'stock',
    },
    {
      name: "Rezervisano",
      id: 'reserved',
    },
    {
      name: "Kapara",
      id: 'deposit',
    },
    {
      name: "Prodato",
      id: 'sold',
    }
  ];

  const showProductList = [
    {
      name: "Admin",
      id: 'admin'
    },
    {
      name: "Radnik",
      id: 'worker',
    }
  ];

  const [sortSelected, setSortSelected] = useState(null);
  const [yearsStart, setYearsStart] = useState([]);
  const [yearsEnd, setYearsEnd] = useState([]);
  const [priceStart, setPriceStart] = useState([]);
  const [priceEnd, setPriceEnd] = useState([]);
  const [categoriesList, setCategoriesList] = useState([]);
  const [manufacturersList, setManufacturersList] = useState([]);
  const [modelsList, setModelsList] = useState([]);
  const [productFilter, setProductFilter] = useState({
    category_id: null,
    manufacturer_id: null,
    sort: null,
    model_id: null,
    query: "",
    status: null,
    view: null
  });

  let {
    value: categoryValue,
    valueChangeHandler: categoryValueChangeHandler,
    reset: resetCategory
  } = useInput((value) => value);

  let {
    value: manufacturerValue,
    valueChangeHandler: manufacturerValueChangeHandler,
    reset: resetManufacturer
  } = useInput((value) => value);

  let {
    value: modelValue,
    valueChangeHandler: modelValueChangeHandler,
    reset: resetModel
  } = useInput((value) => value);

  let {
    value: statusValue,
    valueChangeHandler: statusValueChangeHandler,
    reset: resetStatus
  } = useInput((value) => value);

  let {
    value: showProductValue,
    valueChangeHandler: showProductValueChangeHandler,
    reset: resetShowProduct
  } = useInput((value) => value);

  const [search, setSearch] = useState('');
  const [showMobileFilters, setShowMobileFilters] = useState(false);

  let {
    value: priceStartValue,
    valueChangeHandler: priceStartValueChangeHandler
  } = useInput((value) => value);

  let {
    value: priceEndValue,
    valueChangeHandler: priceEndValueChangeHandler,
    reset: resetPriceEnd
  } = useInput((value) => value);

  let {
    value: yearStartValue,
    valueChangeHandler: yearStartValueChangeHandler
  } = useInput((value) => value);

  let {
    value: yearEndValue,
    valueChangeHandler: yearEndValueChangeHandler,
    reset: resetYearEnd
  } = useInput((value) => value);

  useEffect(() => {
    const timeOutId = setTimeout(() => {
      const data = JSON.parse(JSON.stringify(productFilter));
      if (data.query != search) {
        data.query = search;
        setProductFilter(data);
      }
    }, 500);
    return () => clearTimeout(timeOutId);
  }, [search]);

  const sortChangeHandler = (ev) => {
    setSortSelected(ev.id);
    const data = JSON.parse(JSON.stringify(productFilter));
    data.sort = ev.id;
    setProductFilter(data);
  };

  const categoryChangeHandler = (ev) => {
    const valueInput = {target: {value : (ev && ev.id !== null) ? ev.id : ev}};
    categoryValueChangeHandler(valueInput);
    const data = JSON.parse(JSON.stringify(productFilter));
    data.category_id = (ev && ev.id !== null) ? ev.id : ev;
    getManufacturers(data);
  };

  const manufacturerChangeHandler = (ev) => {
    const valueInput = {target: {value : (ev && ev.id !== null) ? ev.id : ev}};
    manufacturerValueChangeHandler(valueInput);
    const data = JSON.parse(JSON.stringify(productFilter));
    data.manufacturer_id = (ev && ev.id !== null) ? ev.id : ev;
    data.model_id = null;
    getCategories(data);
    getModels(data, true);
    resetModel();
  };

  const modelChangeHandler = (ev) => {
    const valueInput = {target: {value : (ev && ev.id !== null) ? ev.id : ev}};
    modelValueChangeHandler(valueInput);
    const data = JSON.parse(JSON.stringify(productFilter));
    data.model_id = (ev && ev.id !== null) ? ev.id : ev;
    setProductFilter(data);
  };

  const statusChangeHandler = (ev) => {
    const valueInput = {target: {value : (ev && ev.id !== null) ? ev.id : ev}};
    statusValueChangeHandler(valueInput);
    const data = JSON.parse(JSON.stringify(productFilter));
    data.status = (ev && ev.id !== null) ? ev.id : ev;
    setProductFilter(data);
  };

  const showProductChangeHandler = (ev) => {
    const valueInput = {target: {value : (ev && ev.id !== null) ? ev.id : ev}};
    showProductValueChangeHandler(valueInput);
    const data = JSON.parse(JSON.stringify(productFilter));
    data.view = (ev && ev.id !== null) ? ev.id : ev;
    setProductFilter(data);
  };

  const yearStartChangeHandler = (ev) => {
    const valueInput = {target: {value : (ev && ev.id !== null) ? ev.id : ev}};
    const data = JSON.parse(JSON.stringify(productFilter));
    if (ev?.id) {
      const currentYear = new Date().getFullYear();
      const years = Array.from({ length: currentYear - ev.id + 1 }, (_, index) => {
        const year = currentYear - index;
        return { id: year, name: year.toString() };
      });
      setYearsEnd(years);
      if (yearEndValue && yearEndValue < ev.id) {
        resetYearEnd();
        data.year_to = null;
      }
    } else {
      setYearsEnd(yearsStart);
    }
    data.year_from = (ev && ev.id !== null) ? ev.id : ev;
    setProductFilter(data);
    yearStartValueChangeHandler(valueInput);
  };

  const yearEndChangeHandler = (ev) => {
    const valueInput = {target: {value : (ev && ev.id !== null) ? ev.id : ev}};
    yearEndValueChangeHandler(valueInput);
    const data = JSON.parse(JSON.stringify(productFilter));
    data.year_to = (ev && ev.id !== null) ? ev.id : ev;
    setProductFilter(data);
  };

  const priceStartChangeHandler = (ev) => {
    const valueInput = {target: {value : (ev && ev.id !== null) ? ev.id : ev}};
    const data = JSON.parse(JSON.stringify(productFilter));
    setProductFilter(data);
    if (ev?.id) {
      const filteredData = priceStart.filter(item => item.id >= ev.id);
      setPriceEnd(filteredData);       
      if (priceEndValue && priceEndValue < ev.id) {
        resetPriceEnd();
        data.price_to = null;
      }
    } else {
      setPriceEnd(priceStart);
    }
    data.price_from = (ev && ev.id !== null) ? ev.id : ev;
    setProductFilter(data);
    priceStartValueChangeHandler(valueInput);
  };

  const priceEndChangeHandler = (ev) => {
    const valueInput = {target: {value : (ev && ev.id !== null) ? ev.id : ev}};
    priceEndValueChangeHandler(valueInput);
    const data = JSON.parse(JSON.stringify(productFilter));
    data.price_to = (ev && ev.id !== null) ? ev.id : ev;
    setProductFilter(data);
  };

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: currentYear - 1959 }, (_, index) => {
      const year = currentYear - index;
      return { id: year, name: year.toString() };
    });
    setYearsStart(years);
    setYearsEnd(years);
  }, []);


  useEffect(() => {
    // getCategories({}, true);
    // getManufacturers({}, true);
  }, []);

  useEffect(() => {
  if (user?.is_admin) {
    getModels(productFilter, true);
  } else {
    setModelsList([]);
    const data = JSON.parse(JSON.stringify(productFilter));
    data.model_id = null;
    data.query = "";
    data.status = null;
    data.view = null;

    setProductFilter(data);
    setSearch('');
  }
    getManufacturers({}, true);
    resetModel();
  }, [user]);


  const getCategories = async (data, callProducts) => {
    const currentTime = new Date(new Date().getTime());
    localStorage.setItem('lastHttp', currentTime);
    try {
      const response = await fetch(
        "https://api.bagi.rs/api/v1/get/site/categories",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${user?.access_token}`
          },
          body: JSON.stringify(
            {
              manufacturer_id: data?.manufacturer_id ?? null
            }
          )
        }
      );

      if (!response.ok) {
        throw new Error("Error updating data");
      }

      const updatedData = await response.json();
      if (data?.category_id) {
        if (updatedData?.data?.categories?.length > 0) {
          if (doesIdExist(updatedData.data.categories, data.category_id)) {
            setProductFilter(data);
          } else {
            data.category_id = null;
            resetCategory();
            setProductFilter(data);
          }
        } else {
          data.category_id = null;
          resetCategory();
          setProductFilter(data);
        }
      } else if (!callProducts) {
        setProductFilter(data);
      }
      setCategoriesList(updatedData?.data?.categories ?? []);
    } catch (error) {
      console.log(error.message);
    }
  };

  const getManufacturers = async (data, callProducts) => {
    const currentTime = new Date(new Date().getTime());
    localStorage.setItem('lastHttp', currentTime);

    var dataForSave = new FormData();
    dataForSave.append("email", 'ugi slina');

    try {
      const response = await fetch(
        "https://api.bagi.rs/api/v1/contact-form/send",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: dataForSave
          // body: JSON.stringify(
          //   {
          //     email: 'ugi slina'
          //   }
          // )
        }
      );

      if (!response.ok) {
        throw new Error("Error updating data");
      }

      const updatedData = await response.json();
      setProductFilter(data);
      setModelsList(updatedData?.data?.models ?? []);
    } catch (error) {
      console.log(error.message);
    }
    try {
      const response = await fetch(
        "https://api.bagi.rs/api/v1/get/site/manufacturers",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${user?.access_token}`
          },
          body: JSON.stringify(
            {
              category_id: data?.category_id ?? null
            }
          )
        }
      );

      if (!response.ok) {
        throw new Error("Error updating data");
      }

      const updatedData = await response.json();
      if (data?.manufacturer_id) {
        if (updatedData?.data?.manufacturers?.length > 0) {
          if (doesIdExist(updatedData.data.manufacturers, data.manufacturer_id)) {
            setProductFilter(data);
          } else {
            data.manufacturer_id = null;
            resetManufacturer();
            setProductFilter(data);
          }
        } else {
          data.manufacturer_id = null;
          resetManufacturer();
          setProductFilter(data);
        }
      } else if (!callProducts) {
        setProductFilter(data);
      }
      setManufacturersList(updatedData?.data?.manufacturers ?? []);
    } catch (error) {
      console.log(error.message);
    }
  };

  const getModels = async (data, callProducts) => {
    const currentTime = new Date(new Date().getTime());
    localStorage.setItem('lastHttp', currentTime);
    
    try {
      const response = await fetch(
        "https://api.bagi.rs/api/v1/get/site/models",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${user?.access_token}`
          },
          body: JSON.stringify(
            {
              manufacturer_id: data?.manufacturer_id ?? null
            }
          )
        }
      );

      if (!response.ok) {
        throw new Error("Error updating data");
      }

      const updatedData = await response.json();
      // if (data?.category_id) {
      //   if (updatedData?.data?.categories?.length > 0) {
      //     if (doesIdExist(updatedData.data.categories, data.category_id)) {
      //       setProductFilter(data);
      //     } else {
      //       data.category_id = null;
      //       resetCategory();
      //       setProductFilter(data);
      //     }
      //   } else {
      //     data.category_id = null;
      //     resetCategory();
      //     setProductFilter(data);
      //   }
      // } else if (!callProducts) {
      // }
      setProductFilter(data);
      setModelsList(updatedData?.data?.models ?? []);
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    const data = [
      { id: 5000, name: "5.000,00" },
      { id: 10000, name: "10.000,00" },
      { id: 20000, name: "20.000,00" },
      { id: 30000, name: "30.000,00" },
      { id: 40000, name: "40.000,00" },
      { id: 50000, name: "50.000,00" },
      { id: 60000, name: "60.000,00" },
      { id: 70000, name: "70.000,00" },
      { id: 80000, name: "80.000,00" },
      { id: 90000, name: "90.000,00" },
      { id: 100000, name: "100.000,00" },
      { id: 125000, name: "125.000,00" },
      { id: 150000, name: "150.000,00" },
      { id: 200000, name: "200.000,00" }
    ];          
    setPriceStart(data);
    setPriceEnd(data);

  }, []);

  const location = useLocation();
  const [lastLocation, setLastLocation] = useState(null);

  useEffect(() => {
    changeFilter(productFilter);
  }, [productFilter]);

  useEffect(() => {
    setLastLocation(location.pathname);

    const navLinkClicked = sessionStorage.getItem('navLinkClicked') === 'true';
    sessionStorage.removeItem('navLinkClicked');

    if (lastLocation && location.pathname === "/" && lastLocation !== "/") {
      if (navLinkClicked) {
        resetFilters();
      } else {
        changeFilter(productFilter);
      }
    } else {
      if (!location.pathname.includes('detalji')) {
        resetFilters();
      }
    }
    
  }, [location]);

  const resetFilters = () => {
    const data = JSON.parse(JSON.stringify(productFilter));
    data.model_id = null;
    data.query = "";
    data.status = null;
    data.view = null;
    data.manufacturer_id = null;
    data.category_id = null;
    data.sort = null;
    resetCategory();
    resetModel();
    resetManufacturer();
    resetStatus();
    resetShowProduct();
    setSortSelected(null);
    setSearch('');

    getCategories(data);
    getManufacturers(data);
    if (user?.is_admin) {
      getModels(data);
    }
    setProductFilter(data);
  }

  // Helper function to get selected filter name
  const getSelectedFilterName = (value, dataList) => {
    if (!value || !dataList) return null;
    const selected = dataList.find(item => item.id === value);
    return selected?.name || null;
  };

  // Helper function to check if any filters are active
  const hasActiveFilters = () => {
    return categoryValue || manufacturerValue || modelValue || statusValue || showProductValue || search;
  };

  return (
    <div className={ location.pathname === '/' ? "sub-header compact-subheader" : "d-none" }>
        <div className="container-fluid">
            <div className="compact-filter-container">
                {/* Main Filters Row */}
                <div className="main-filters-row">
                    <div className="filters-left">
                        <div className={`filter-item category-item ${categoryValue ? 'selected' : ''}`}>
                            <Input
                                value={categoryValue}
                                isMulti={false}
                                handleChange={categoryChangeHandler}
                                disabled={false}
                                data={categoriesList}
                                inputType="select-react"
                                type="text"
                                placeHolder="Kategorija"
                                class="compact-select"
                            />
                            {categoryValue && <div className="selected-badge">{getSelectedFilterName(categoryValue, categoriesList)}</div>}
                        </div>
                        
                        <div className={`filter-item manufacturer-item ${manufacturerValue ? 'selected' : ''}`}>
                            <Input
                                value={manufacturerValue}
                                isMulti={false}
                                handleChange={manufacturerChangeHandler}
                                disabled={false}
                                data={manufacturersList}
                                inputType="select-react"
                                type="text"
                                placeHolder="Proizvođač"
                                class="compact-select"
                            />
                            {manufacturerValue && <div className="selected-badge">{getSelectedFilterName(manufacturerValue, manufacturersList)}</div>}
                        </div>
                        
                        <div className={`filter-item search-item desktop-only ${search ? 'selected' : ''}`}>
                            <div className="search-input-wrapper">
                                <svg className="search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <circle cx="11" cy="11" r="8"></circle>
                                    <path d="m21 21-4.35-4.35"></path>
                                </svg>
                                <input
                                    onChange={(e) => { setSearch(e.target.value) }}
                                    type="text"
                                    className="compact-search-input"
                                    id="searchInput"
                                    aria-describedby="search"
                                    placeholder="Broj tablice"
                                    value={search}
                                />
                            </div>
                            {search && <div className="selected-badge">"{search}"</div>}
                        </div>
                    </div>
                    
                    <div className="filters-right">
                        <div className={`filter-item sort-item desktop-sort ${sortSelected ? 'selected' : ''}`}>
                            <Input
                                value={sortSelected}
                                isMulti={false}
                                handleChange={sortChangeHandler}
                                disabled={false}
                                data={sortList}
                                inputType="select-react"
                                type="text"
                                placeHolder="Sortiranje"
                                class="compact-sort-select"
                                isClearable={false}
                                isSearchable={false}
                            />
                            {sortSelected && <div className="selected-badge sort-badge">{getSelectedFilterName(sortSelected, sortList)}</div>}
                        </div>
                    </div>
                </div>

                {/* Mobile Button Controls */}
                <div className="mobile-controls-row">
                    <button 
                        className={`mobile-filter-btn ${hasActiveFilters() ? 'has-filters' : ''} ${showMobileFilters ? 'expanded' : ''}`}
                        onClick={() => setShowMobileFilters(!showMobileFilters)}
                    >
                        <div className="filter-btn-content">
                            <svg className="filter-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
                            </svg>
                            <span className="filter-text">Filteri</span>
                            {hasActiveFilters() && <div className="active-filters-dot"></div>}
                        </div>
                        <svg className={`expand-icon ${showMobileFilters ? 'rotated' : ''}`} width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="6 9 12 15 18 9"></polyline>
                        </svg>
                    </button>
                    
                    <div className="mobile-sort-wrapper">
                        <Input
                            value={sortSelected}
                            isMulti={false}
                            handleChange={sortChangeHandler}
                            disabled={false}
                            data={sortList}
                            inputType="select-react"
                            type="text"
                            placeHolder="Sortiranje"
                            class="mobile-sort-select"
                            isClearable={false}
                            isSearchable={false}
                        />
                    </div>
                </div>

                {/* Mobile Expandable Filters */}
                <div className={`mobile-filters-expandable ${showMobileFilters ? 'expanded' : ''}`}>
                    <div className="mobile-filter-content">
                        <div className="mobile-filter-row">
                            <div className="mobile-filter-group">
                                <label>Pretraga</label>
                                <div className="search-input-wrapper">
                                    <svg className="search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <circle cx="11" cy="11" r="8"></circle>
                                        <path d="m21 21-4.35-4.35"></path>
                                    </svg>
                                    <input
                                        onChange={(e) => { setSearch(e.target.value) }}
                                        type="text"
                                        className="mobile-search-input"
                                        placeholder="Broj tablice"
                                        value={search}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="mobile-filter-row">
                                <div className="mobile-filter-group">
                                    <label>Kategorija</label>
                                    <Input
                                        value={categoryValue}
                                        isMulti={false}
                                        handleChange={categoryChangeHandler}
                                        disabled={false}
                                        data={categoriesList}
                                        inputType="select-react"
                                        type="text"
                                        placeHolder="Izaberite kategoriju"
                                        class="mobile-filter-select"
                                        menuPosition="fixed"
                                        menuPlacement="auto"
                                    />
                                </div>
                        </div>

                        <div className="mobile-filter-row">
                            <div className="mobile-filter-group">
                                <label>Proizvođač</label>
                                <Input
                                    value={manufacturerValue}
                                    isMulti={false}
                                    handleChange={manufacturerChangeHandler}
                                    disabled={false}
                                    data={manufacturersList}
                                    inputType="select-react"
                                    type="text"
                                    placeHolder="Izaberite proizvođača"
                                    class="mobile-filter-select"
                                    menuPosition="fixed"
                                    menuPlacement="auto"
                                />
                            </div>
                        </div>

                        {user?.is_admin && (
                            <>
                                <div className="mobile-filter-row">
                                    <div className="mobile-filter-group">
                                        <label>Model</label>
                                        <Input
                                            value={modelValue}
                                            isMulti={false}
                                            handleChange={modelChangeHandler}
                                            disabled={false}
                                            data={modelsList}
                                            inputType="select-react"
                                            type="text"
                                            placeHolder="Izaberite model"
                                            class="mobile-filter-select"
                                            menuPosition="fixed"
                                            menuPlacement="auto"
                                        />
                                    </div>
                                </div>

                                <div className="mobile-filter-row">
                                    <div className="mobile-filter-group">
                                        <label>Status</label>
                                        <Input
                                            value={statusValue}
                                            isMulti={false}
                                            handleChange={statusChangeHandler}
                                            disabled={false}
                                            data={statusList}
                                            inputType="select-react"
                                            type="text"
                                            placeHolder="Izaberite status"
                                            class="mobile-filter-select"
                                            menuPosition="fixed"
                                            menuPlacement="auto"
                                        />
                                    </div>
                                </div>

                                <div className="mobile-filter-row">
                                    <div className="mobile-filter-group">
                                        <label>Prikaz vozila</label>
                                        <Input
                                            value={showProductValue}
                                            isMulti={false}
                                            handleChange={showProductChangeHandler}
                                            disabled={false}
                                            data={showProductList}
                                            inputType="select-react"
                                            type="text"
                                            placeHolder="Izaberite prikaz"
                                            class="mobile-filter-select"
                                            menuPosition="fixed"
                                            menuPlacement="auto"
                                        />
                                    </div>
                                </div>
                            </>
                        )}

                        <div className="mobile-filter-actions">
                            <button className="clear-filters-btn" onClick={() => {
                                resetFilters();
                            }}>
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <polyline points="3 6 5 6 21 6"></polyline>
                                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                                </svg>
                                Obriši filtere
                            </button>
                        </div>
                    </div>
                </div>

                {/* Admin Filters */}
                {user?.is_admin && (
                    <div className="admin-filters-row">
                        <div className={`filter-item model-item ${modelValue ? 'selected' : ''}`}>
                            <Input
                                value={modelValue}
                                isMulti={false}
                                handleChange={modelChangeHandler}
                                disabled={false}
                                data={modelsList}
                                inputType="select-react"
                                type="text"
                                placeHolder="Model"
                                class="compact-select admin-select"
                            />
                            {modelValue && <div className="selected-badge admin-badge">{getSelectedFilterName(modelValue, modelsList)}</div>}
                        </div>
                        
                        <div className={`filter-item status-item ${statusValue ? 'selected' : ''}`}>
                            <Input
                                value={statusValue}
                                isMulti={false}
                                handleChange={statusChangeHandler}
                                disabled={false}
                                data={statusList}
                                inputType="select-react"
                                type="text"
                                placeHolder="Status"
                                class="compact-select admin-select"
                            />
                            {statusValue && <div className="selected-badge admin-badge">{getSelectedFilterName(statusValue, statusList)}</div>}
                        </div>
                        
                        <div className={`filter-item view-item ${showProductValue ? 'selected' : ''}`}>
                            <Input
                                value={showProductValue}
                                isMulti={false}
                                handleChange={showProductChangeHandler}
                                disabled={false}
                                data={showProductList}
                                inputType="select-react"
                                type="text"
                                placeHolder="Prikaz vozila"
                                class="compact-select admin-select"
                            />
                            {showProductValue && <div className="selected-badge admin-badge">{getSelectedFilterName(showProductValue, showProductList)}</div>}
                        </div>
                    </div>
                )}

            </div>
        </div>
    </div>
  );
}

export default SubHeader;
